import Vue from 'vue'
import App from './App.vue'
import router from './router'


// 引入组件库
import iView from 'iview';
import 'iview/dist/styles/iview.css';
Vue.use(iView);

// 引入iconfont
import "@/assets/iconfont/iconfont.css"
// 字体
import "@/assets/font/font.css"



Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
